import { supabase } from '../lib/supabase'
import {
  HelpdeskModule,
  CreateHelpdeskModuleData,
  UpdateHelpdeskModuleData,
  ApiResponse
} from '../types'

export const helpdeskModulesService = {
  async getAll(): Promise<ApiResponse<HelpdeskModule[]>> {
    try {
      const { data, error } = await supabase
        .from('helpdesk_modules')
        .select('*')
        .order('order_index', { ascending: true })

      if (error) throw error

      return { data: (data || []) as HelpdeskModule[], success: true }
    } catch (error) {
      return { data: [], error: (error as Error).message, success: false }
    }
  },

  async getById(id: string): Promise<ApiResponse<HelpdeskModule>> {
    try {
      const { data, error } = await supabase
        .from('helpdesk_modules')
        .select('*')
        .eq('id', id)
        .single()

      if (error) throw error

      return { data: data as HelpdeskModule, success: true }
    } catch (error) {
      return { data: {} as HelpdeskModule, error: (error as Error).message, success: false }
    }
  },

  async create(moduleData: CreateHelpdeskModuleData & { is_active?: boolean }): Promise<ApiResponse<HelpdeskModule>> {
    try {
      const { data, error } = await supabase
        .from('helpdesk_modules')
        .insert(moduleData)
        .select()
        .single()

      if (error) throw error

      return { data: data as HelpdeskModule, success: true }
    } catch (error) {
      return { data: {} as HelpdeskModule, error: (error as Error).message, success: false }
    }
  },

  async update(id: string, moduleData: UpdateHelpdeskModuleData): Promise<ApiResponse<HelpdeskModule>> {
    try {
      const { data, error } = await supabase
        .from('helpdesk_modules')
        .update(moduleData)
        .eq('id', id)
        .select()
        .single()

      if (error) throw error

      return { data: data as HelpdeskModule, success: true }
    } catch (error) {
      return { data: {} as HelpdeskModule, error: (error as Error).message, success: false }
    }
  },

  async delete(id: string): Promise<ApiResponse<void>> {
    try {
      const { error } = await supabase
        .from('helpdesk_modules')
        .delete()
        .eq('id', id)

      if (error) throw error

      return { data: undefined, success: true }
    } catch (error) {
      return { data: undefined, error: (error as Error).message, success: false }
    }
  }
}
